import { render, staticRenderFns } from "./StrapUnderDial.vue?vue&type=template&id=6fdc798c&scoped=true&"
import script from "./StrapUnderDial.vue?vue&type=script&lang=js&"
export * from "./StrapUnderDial.vue?vue&type=script&lang=js&"
import style0 from "./StrapUnderDial.vue?vue&type=style&index=0&id=6fdc798c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc798c",
  null
  
)

export default component.exports